import { createSvgIcon } from '@mui/material';

const CloseIcon = createSvgIcon(
  <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect width='40' height='40' rx='8' fill='#F6F8FF' />
    <path
      d='M25.2496 14.7584C24.9246 14.4334 24.3996 14.4334 24.0746 14.7584L19.9996 18.8251L15.9246 14.7501C15.5996 14.4251 15.0746 14.4251 14.7496 14.7501C14.4246 15.0751 14.4246 15.6001 14.7496 15.9251L18.8246 20.0001L14.7496 24.0751C14.4246 24.4001 14.4246 24.9251 14.7496 25.2501C15.0746 25.5751 15.5996 25.5751 15.9246 25.2501L19.9996 21.1751L24.0746 25.2501C24.3996 25.5751 24.9246 25.5751 25.2496 25.2501C25.5746 24.9251 25.5746 24.4001 25.2496 24.0751L21.1746 20.0001L25.2496 15.9251C25.5663 15.6084 25.5663 15.0751 25.2496 14.7584Z'
      fill='#1749D1'
    />
  </svg>,
  'Close',
);

export default CloseIcon;
